import React, { useState, useMemo, useEffect, useRef } from 'react';
import { Button, Modal, Form, InputGroup, Row, Col, Spinner, Alert, Table, Image, Tabs, Tab, Pagination, Badge, Accordion } from 'react-bootstrap'; // Adiciona Pagination e Accordion
import TableComponent from '../../components/Table'; // Ajustado: Sobe dois níveis para src/, depois entra em components/
import Select from 'react-select'; // 1. Importar o react-select
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputMask from 'react-input-mask';
import axios from 'axios';
import config from '../../config'; // Ajustado: Sobe dois níveis para src/
import { useEntidadeContext } from '../../EntidadeContext'; // Ajustado: Sobe dois níveis para src/
import { useUserContext } from '../../UserContext'; // Importar para verificar a role do usuário
import ImportacaoPacientesTab from './ImportacaoPacientesTab'; // Importar o novo componente de importação
import ProntuarioVisualizacaoModal from './ProntuarioVisualizacaoModal'; // Importar o novo modal
import '../../index.css'; // Ajustado: Sobe dois níveis para src/
import { useAlertModal } from '../../AlertModalContext';

// const TIPO_FICHA = 'Esteticista';
// const TIPO_FICHA = 'Dentista';
const TIPO_FICHA = 'Medico'; 

// Função para normalizar strings (remover acentos e converter para minúsculas)
function normalizeString(str) {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

// Função para validar o formato do email
const isValidEmail = (email) => {
  if (!email) return true; // Se o email for vazio, considera válido para não ser obrigatório
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};


//Busca o CEP na API dos Correios  
const buscarEnderecoPorCep = async (cep) => {
  const response = await axios.get(`${config.apiCep}${cep}/json/`);
  return response.data;
};

const PacientesTab = ({ pacientesList, onPatientCreated, onPatientUpdated, onPatientDeleted }) => { // Recebe pacientesList e callbacks do pai
  const [pacientes, setPacientes] = useState([]);
  const { showAlertModal } = useAlertModal();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pacienteToDelete, setPacienteToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // Add a loading state
  const [isLoadingMessage, setIsLoadingMessage] = useState(''); // New state for the message
  const { currentUserRole } = useUserContext(); // Obter a role do usuário
  const { currentEntidade, isLoadingEntidade } = useEntidadeContext(); // Usar contexto


  const nomeRef = useRef(null); // Define here
  const cpfRef = useRef(null); 
  const emailRef = useRef(null);
  const celularRef = useRef(null); 

  const [showAlert, setShowAlert] = useState(false); // State for alert visibility
  const [alertMessage, setAlertMessage] = useState(''); // State for alert message

  // Monta modal Prontuário Paciente
  const [showProntuarioModal, setShowProntuarioModal] = useState(false); // Agora controla o novo modal
  const [pacienteParaVisualizar, setPacienteParaVisualizar] = useState(null); // Paciente para o modal

  // Estado para o modal de importação
  const [showImportModal, setShowImportModal] = useState(false);


  // Tela Modal para anamnese:
  const [showAnamneseModal, setShowAnamneseModal] = useState(false);
  const [anamnesePerguntas, setAnamnesePerguntas] = useState([]);
  const [anamneseRespostas, setAnamneseRespostas] = useState({});
  const [creatingAnamnese, setCreatingAnamnese] = useState(false);
  const [existingAnamnese, setExistingAnamnese] = useState(null); // State to store existing anamnese

  const [fotoPaciente, setFotoPaciente] = useState(null); // Estado para o arquivo da foto
  const [previewFotoPaciente, setPreviewFotoPaciente] = useState(null); // Estado para o preview da foto

  // Estados para a câmera
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  // Flag para controlar a busca inicial de pacientes NESTA montagem
  const fetchPacientesAttemptedInThisMount = useRef(false);

  // Estados para paginação
  const [activePage, setActivePage] = useState(1);
  const itemsPerPage = 10; // Limite de pacientes por página

  // Estado para o termo de busca
  const [searchTerm, setSearchTerm] = useState('');

  // Estado para controlar a aba ativa DENTRO do modal de paciente
  const [activeModalTabKey, setActiveModalTabKey] = useState('dadosPrincipais');

    // 2. Estados para as tags de interesse
  const [allTags, setAllTags] = useState([]);
  const [isLoadingTags, setIsLoadingTags] = useState(false);

  // Estados para o modal principal de paciente (movidos para o topo)
  const [showModal, setShowModal] = useState(false);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [pacienteSelecionado, setPacienteSelecionado] = useState({
    id: 0,
    nome: '',
    email: '',
    telefone: '',
      cpf: '',
      data_nascimento: null,
      sexo: 'N',
      estado_civil: 'Nao informado',
      cor: 'Nao Informado',
      profissao: '',
      mae: '',
      pai: '',
      tp_convenio: '',
      op_convenio: '',
      nu_convenio: '',
      nu_sus: '',
      nm_acompanhante: '',
      cpf_acompanhante: '',
      obs: '',
      cep: '',
      tipoendereco: 'Residencial',
      estado: '',
      cidade: '',
      bairro: '',
      endereco: '',
      numero: '',
      complemento: '',
      dddcelular: '', // Adicionado para consistência com o formulário
      celular: '',    // Adicionado para consistência com o formulário
      dddtelefone: '', // Adicionado para consistência com o formulário
      interesses: [], // 3. Adicionado para armazenar os interesses do paciente
      foto_path: null, // Adicionado para clareza
      interesses: [], // Limpa os interesses
  });
  // Estados para carregamento lazy dos dados adicionais no modal de edição
  const [isLoadingAdicionais, setIsLoadingAdicionais] = useState(false);
  const [adicionaisFetchedForId, setAdicionaisFetchedForId] = useState(null);

  // Estados para o histórico de pacotes
  const [pacotesHistorico, setPacotesHistorico] = useState([]);
  const [isLoadingHistorico, setIsLoadingHistorico] = useState(false);
  const [historicoFetchedForId, setHistoricoFetchedForId] = useState(null);

  const handleShowAnamnese = async (paciente) => {
    setPacienteSelecionado(paciente);
    try {
      // Fetch anamnese questions
      const perguntasResponse = await axios.get(`/api/panamneses?tipo_ficha=${TIPO_FICHA}`);
      setAnamnesePerguntas(perguntasResponse.data);

      // Fetch existing anamnese for the patient
      const anamneseResponse = await axios.get(`/api/anamneses?paciente_id=${paciente.id}`);
      setExistingAnamnese(anamneseResponse.data.anamneses[0]); // Assuming only one anamnese per patient for now

      setShowAnamneseModal(true);
    } catch (error) {
      console.error('Erro ao buscar perguntas da anamnese:', error);
      // Handle error, e.g., display an error message to the user
    }
  };

  const handleAnamneseChange = (perguntaId, resposta) => {
    setAnamneseRespostas(prevRespostas => ({
      ...prevRespostas,
      [perguntaId]: resposta,
    }));
  };

  const handleSubmitAnamnese = async (pacienteId) => {
    setCreatingAnamnese(true);
    try {
      const respostasArray = Object.entries(anamneseRespostas).map(([perguntaId, resposta]) => ({
        pergunta_id: parseInt(perguntaId, 10), // Convert perguntaId to integer
        resposta: resposta,
      }));

      const response = await axios.post(`/api/anamneses`, {
        paciente_id: pacienteId,
        tipo_ficha: 'Esteticista',
        respostas: respostasArray,
      });

      setShowAnamneseModal(false);
      setAnamneseRespostas({}); // Clear the responses after submission
    } catch (error) {
      console.error('Erro ao criar anamnese:', error);
      // Handle error, e.g., display an error message to the user
    } finally {
      setCreatingAnamnese(false);
    }
  };

  // Sincroniza a lista de pacientes recebida via prop com o estado local
  // Isso é importante para que as operações locais (filtro, etc.) funcionem
  useEffect(() => {
    setPacientes(pacientesList);
  }, [pacientesList]);

  // 4. useEffect para buscar TODAS as tags de interesse disponíveis quando o modal abre
  useEffect(() => {
    const fetchAllTags = async () => {
      if (!showModal || !currentEntidade) return; // Só busca se o modal estiver aberto
      if (allTags.length > 0) return; // Não busca novamente se já tiver carregado

      setIsLoadingTags(true);
      try {
        // Endpoint que busca todas as tags de interesse da entidade
        const response = await axios.get(`/api/interesses?entidade_id=${currentEntidade.id}`);
        const formattedTags = (response.data.interesses || []).map(tag => ({
          value: tag.id,
          label: tag.nome
        }));
        setAllTags(formattedTags);
      } catch (error) {
        console.warn("API de interesses não encontrada, usando dados mocados para o modal de paciente.");
        setAllTags([
          { value: 1, label: 'Botox' }, { value: 2, label: 'Protocolo Capilar' }, { value: 3, label: 'Limpeza de Pele' },
        ]);
      } finally {
        setIsLoadingTags(false);
      }
    };
    fetchAllTags();
  }, [showModal, currentEntidade, allTags.length]);

  // Efeito para resetar a página para 1 quando a busca mudar
  useEffect(() => {
    setActivePage(1);
  }, [searchTerm]);

  // useEffect para buscar dados adicionais quando a aba "Dados Adicionais" é ativada no modal de edição
  useEffect(() => {
    const fetchDadosAdicionais = async (pacienteId) => {
      if (!pacienteId || !currentEntidade) return;
      setIsLoadingAdicionais(true);
      try {
        // 5. Busca os detalhes do paciente e os interesses dele em paralelo
        const [pacienteDetailsRes, pacienteInteressesRes] = await Promise.all([
          axios.get(`/api/pacientes/${pacienteId}`),
          axios.get(`/api/pacientes/${pacienteId}/interesses`) // BACKEND: Este endpoint precisará ser criado
        ]);

        const dadosCompletos = pacienteDetailsRes.data;
        // Mock dos interesses do paciente se a API falhar
        const interessesDoPaciente = pacienteInteressesRes.data.interesses || [{ id: 1, nome: 'Botox' }];

        // Formata os interesses para o formato do react-select
        const formattedInteresses = interessesDoPaciente.map(tag => ({
          value: tag.id,
          label: tag.nome
        }));
        
        // Mescla os dados completos com o que já existe, formatando a data se necessário
        // No caso de edição, pacienteSelecionado já terá id e nome do basic-info.
        // Esta chamada irá popular os demais campos.
        setPacienteSelecionado(prev => ({
          ...prev, // Mantém os dados básicos (como o ID) que já estavam no estado.
          ...dadosCompletos, // 1. Espalha os dados completos da API primeiro.
          interesses: formattedInteresses, // 2. Sobrescreve a chave 'interesses' com os dados já formatados para o Select.
          data_nascimento: dadosCompletos.data_nascimento ? new Date(dadosCompletos.data_nascimento) : null,
        }));
        // Atualiza o preview da foto após carregar os dados completos
        if (dadosCompletos.foto_path) {
          setPreviewFotoPaciente(`${config.apiBaseURL}/storage/${dadosCompletos.foto_path}`);
        } else {
          setPreviewFotoPaciente(null);
        }

        setAdicionaisFetchedForId(pacienteId); // Marca que os dados foram buscados
      } catch (error) {
        console.error('Erro ao buscar dados adicionais do paciente:', error);
        // Se a busca de interesses falhar, podemos deixar o array vazio
        setPacienteSelecionado(prev => ({
          ...prev, interesses: []
        }));
        // Tratar erro, talvez com um alerta
      } finally {
        setIsLoadingAdicionais(false);
      }
    };

    // Busca dados adicionais assim que o modal de edição é aberto para um paciente cujo ID não foi buscado ainda
    if (showModal && modoEdicao && pacienteSelecionado?.id && adicionaisFetchedForId !== pacienteSelecionado.id) {
      fetchDadosAdicionais(pacienteSelecionado.id);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal, modoEdicao, pacienteSelecionado?.id, currentEntidade, adicionaisFetchedForId]); // Dependências corretas

  // useEffect para buscar o histórico de pacotes quando a aba "Pacotes" é ativada
  useEffect(() => {
    const fetchHistoricoPacotes = async (pacienteId) => {
      if (!pacienteId || !currentEntidade) return;
      setIsLoadingHistorico(true);
      try {
        const response = await axios.get(`/api/pacientes/${pacienteId}/pacotes-com-historico`);
        setPacotesHistorico(response.data.pacotes_historico || []);
        setHistoricoFetchedForId(pacienteId); // Marca que os dados foram buscados
      } catch (error) {
        console.error('Erro ao buscar histórico de pacotes:', error);
        setPacotesHistorico([]);
      } finally {
        setIsLoadingHistorico(false);
      }
    };

    // Busca os dados se a aba de pacotes estiver ativa, o modal estiver aberto,
    // houver um paciente selecionado e os dados para ele ainda não foram buscados.
    if (showModal && activeModalTabKey === 'pacotes' && pacienteSelecionado?.id && historicoFetchedForId !== pacienteSelecionado.id) {
      fetchHistoricoPacotes(pacienteSelecionado.id);
    }
  }, [showModal, activeModalTabKey, pacienteSelecionado?.id, currentEntidade, historicoFetchedForId]);


  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => {
    setModoEdicao(false);
    setPacienteSelecionado({       
      id: 0,
      nome: '',
      email: '',
      telefone: '',
      cpf: '',
      data_nascimento: null,
      sexo: 'N',
      estado_civil: 'Nao informado',
      cor: 'Nao Informado',
      profissao: '',
      mae: '',
      pai: '',
      tp_convenio: '',
      op_convenio: '',
      nu_convenio: '',
      nu_sus: '',
      nm_acompanhante: '',
      cpf_acompanhante: '',
      obs: '',
      cep: '',
      tipoendereco: 'Residencial',
      estado: '',
      cidade: '',
      bairro: '',
      endereco: '',
      numero: '',
      complemento: '',
      dddcelular: '',
      celular: '',
      dddtelefone: '',
      foto_path: null, // Resetar foto_path
 });
    setFotoPaciente(null); // Limpa foto ao abrir modal de novo paciente
        setActiveModalTabKey('dadosPrincipais'); // Reseta para a aba principal

    setPreviewFotoPaciente(null); // Limpa preview
    stopCameraStream(); // Garante que a câmera pare se estiver aberta

    setShowModal(true);
  };

  const handleEditar = (paciente) => {
    setModoEdicao(true);
    
    // Inicialmente, define pacienteSelecionado com os dados básicos (id, nome)
    // Os dados completos serão buscados pelo useEffect que monitora showModal e modoEdicao
    setPacienteSelecionado({
      ...paciente,
      interesses: [], // Começa com interesses vazios, serão buscados depois
      // Outros campos serão preenchidos pelo fetchDadosAdicionais
      // data_nascimento será null inicialmente e preenchido/convertido após o fetch completo
      data_nascimento: null     });
    setShowModal(true);
    setAdicionaisFetchedForId(null); // Reseta para forçar o fetch se a aba for clicada
    setActiveModalTabKey('dadosPrincipais'); // Reseta para a aba principal
    setHistoricoFetchedForId(null); // Reseta o histórico de pacotes

    setFotoPaciente(null); // Limpa a seleção de um NOVO arquivo de foto

    // Define o preview da foto existente
    // Como 'paciente' vem do basic-info, ele não terá foto_path aqui.
    // O preview será definido após o fetch dos dados completos.
    // if (paciente.foto_path) {

      // Constrói a URL completa da imagem
      // Assume que as imagens estão em public/storage e acessíveis via /storage/
      // e que config.apiBaseURL é a URL base do seu backend (ex: http://localhost:8000)
      // setPreviewFotoPaciente(`${config.apiBaseURL}/storage/${paciente.foto_path}`);
    // } else {
      setPreviewFotoPaciente(null); // Nenhuma foto cadastrada
    stopCameraStream();
  };


  const handleSalvar = async () => {
    if (!currentEntidade) {
      setAlertMessage('Erro: Nenhuma entidade selecionada. Não é possível salvar o paciente.');
      setShowAlert(true);
      return;
    }

    // 1. Validation
    if (!pacienteSelecionado.nome || !pacienteSelecionado.dddcelular || 
        !pacienteSelecionado.celular) {

      const camposFaltando = [];
      if (!pacienteSelecionado.nome) camposFaltando.push('Nome Completo');
      if (!pacienteSelecionado.dddcelular) camposFaltando.push('DDD Celular');
      if (!pacienteSelecionado.celular) camposFaltando.push('Celular');

      setAlertMessage(`Por favor, preencha os seguintes campos obrigatórios: ${camposFaltando.join(', ')}.`);
      setShowAlert(true);
      setActiveModalTabKey('dadosPrincipais'); // Garante que a aba com campos obrigatórios esteja visível
      
      // Adiciona a classe 'is-invalid' aos campos obrigatórios faltantes
      if (nomeRef.current && !pacienteSelecionado.nome) nomeRef.current.classList.add('is-invalid');
      if (celularRef.current && !pacienteSelecionado.celular) celularRef.current.classList.add('is-invalid');
      return; 
    }

    // 2. Validação do formato do email
    if (pacienteSelecionado.email && !isValidEmail(pacienteSelecionado.email)) {
      setAlertMessage('Por favor, insira um formato de email válido (ex: nome@dominio.com).');
      setShowAlert(true);
      setActiveModalTabKey('dadosPrincipais');
      if (emailRef.current) {
        emailRef.current.classList.add('is-invalid');
      }
      return;
    }

    // 3. Validação do tamanho do celular
    if (pacienteSelecionado.celular && (pacienteSelecionado.celular.length < 8 || pacienteSelecionado.celular.length > 9)) {
      setAlertMessage('O número do celular deve ter entre 8 e 9 dígitos, sem contar o DDD.');
      setShowAlert(true);
      setActiveModalTabKey('contato'); // Direciona para a aba de contato
      if (celularRef.current) {
        // O ref está no Form.Control dentro do InputMask
        celularRef.current.classList.add('is-invalid');
      }
      return;
    }

    if (nomeRef.current) nomeRef.current.classList.remove('is-invalid');
    if (celularRef.current) celularRef.current.classList.remove('is-invalid');


    //Editar um paciente
    if (modoEdicao) {
      // Call handleCreatePatient to edit a new patient
      setIsLoading(true); // Show loading indicator
      setIsLoadingMessage('Atualizando paciente...');
      await handleEditPatient(); // Wait for the API call to complete
      setIsLoading(false); // Hide loading indicator
    } else {  
      // Call handleCreatePatient to create a new patient
      setIsLoading(true); // Show loading indicator
      setIsLoadingMessage('Criando paciente...');
      await handleCreatePatient(); // Wait for the API call to complete
      setIsLoading(false); // Hide loading indicator
    }
  };

  const handleCreatePatient = async () => {
    if (!currentEntidade) {
      alert('Entidade não selecionada. Não é possível criar o paciente.');
      return;
    }

    try {
      // 1. Prepare the patient data
      // Usa FormData para enviar texto e arquivo
      const formData = new FormData();

      // Adiciona os dados do paciente ao FormData
      formData.append('entidade_id', currentEntidade.id); // Associate with the current entity

      // 1. Prepare the patient data
      const newPatientData = {
        user_id: 1,
        nome: pacienteSelecionado.nome,
        cpf: pacienteSelecionado.cpf,
        email: pacienteSelecionado.email,
        dddcelular: pacienteSelecionado.dddcelular,
        celular: pacienteSelecionado.celular,
        data_nascimento: pacienteSelecionado.data_nascimento ? pacienteSelecionado.data_nascimento.toISOString().split('T')[0] : null, // Format date
        sexo: pacienteSelecionado.sexo,
        estado_civil: pacienteSelecionado.estado_civil,
        cor: pacienteSelecionado.cor,
        profissao: pacienteSelecionado.profissao,
        mae: pacienteSelecionado.mae,
        pai: pacienteSelecionado.pai,
        tp_convenio: pacienteSelecionado.tp_convenio,
        op_convenio: pacienteSelecionado.op_convenio,
        nu_convenio: pacienteSelecionado.nu_convenio,
        nu_sus: pacienteSelecionado.nu_sus,
        nm_acompanhante: pacienteSelecionado.nm_acompanhante,
        cpf_acompanhante: pacienteSelecionado.cpf_acompanhante,
        obs: pacienteSelecionado.obs,
        cep: pacienteSelecionado.cep,
        tipoendereco: pacienteSelecionado.tipoendereco,
        estado: pacienteSelecionado.estado,
        cidade: pacienteSelecionado.cidade,
        bairro: pacienteSelecionado.bairro,
        endereco: pacienteSelecionado.endereco,
        numero: pacienteSelecionado.numero,
        complemento: pacienteSelecionado.complemento,
        dddtelefone: pacienteSelecionado.dddtelefone,
        telefone: pacienteSelecionado.telefone,
        sigilo: pacienteSelecionado.sigilo,
      };
  
      for (const key in newPatientData) {
        if (newPatientData[key] !== null && newPatientData[key] !== undefined) {
          formData.append(key, newPatientData[key]);
        }
      }

      // Adiciona a foto se existir
      if (fotoPaciente) {
        formData.append('foto', fotoPaciente); // 'foto' é o nome do campo esperado pela API
      }

    // 7. Adiciona os interesses ao FormData
      if (pacienteSelecionado.interesses) {
        pacienteSelecionado.interesses.forEach((tag) => formData.append('interesses[]', tag.value));
      }
  
      // Faz a requisição POST com FormData
      const response = await axios.post(`/api/pacientes`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 201) { // 201 Created status code
        const newPaciente = response.data.paciente;
        setPacientes(prevPacientes => [...prevPacientes, newPaciente]);

        // Notifica o componente pai (Consultorio.js) que um novo paciente foi criado.
        if (onPatientCreated) {
          onPatientCreated(newPaciente);
        }
        handleCloseModal();
        // Optionally, display a success message to the user
        // alert('Paciente criado com sucesso!');
      } else {
        console.error('Error creating patient:', response.data);
        // Display an error message to the user
        alert('Erro ao criar paciente. Por favor, tente novamente.');
      }
    } catch (error) {
      console.error('Error creating patient:', error);
      let msg = 'Erro ao criar paciente. Por favor, verifique sua conexão.';
      if (error.response && error.response.data) {
        if (error.response.data.errors) {
          msg = Object.values(error.response.data.errors).flat().join('\n');
        } else {
          msg = error.response.data.message || msg;
        }
      }
      msg = msg.replace(/The cpf has already been taken/gi, 'Este CPF já está cadastrado.');
      msg = msg.replace(/The email has already been taken/gi, 'Este E-mail já está cadastrado.');
      showAlertModal('Erro', msg, 'danger');
    }
  };

  const handleEditPatient = async () => {
    if (!currentEntidade) {
      alert('Entidade não selecionada. Não é possível editar o paciente.');
      return;
    }

    try {
      // 1. Prepare the patient data
      // Usa FormData para enviar texto e possivelmente arquivo
      const formData = new FormData();

      const updatedPatientData = {
        entidade_id: currentEntidade.id, // Ensure association with the current entity
        nome: pacienteSelecionado.nome,
        cpf: pacienteSelecionado.cpf,
        email: pacienteSelecionado.email,
        dddcelular: pacienteSelecionado.dddcelular,
        celular: pacienteSelecionado.celular,
        // data_nascimento: pacienteSelecionado.data_nascimento ? pacienteSelecionado.data_nascimento.toISOString().split('T')[0] : null, // Format date
        data_nascimento: pacienteSelecionado.data_nascimento 
            ? new Date(pacienteSelecionado.data_nascimento).toISOString().split('T')[0] 
            : null,
        sexo: pacienteSelecionado.sexo,
        estado_civil: pacienteSelecionado.estado_civil,
        cor: pacienteSelecionado.cor,
        profissao: pacienteSelecionado.profissao,
        mae: pacienteSelecionado.mae,
        pai: pacienteSelecionado.pai,
        tp_convenio: pacienteSelecionado.tp_convenio,
        op_convenio: pacienteSelecionado.op_convenio,
        nu_convenio: pacienteSelecionado.nu_convenio,
        nu_sus: pacienteSelecionado.nu_sus,
        nm_acompanhante: pacienteSelecionado.nm_acompanhante,
        cpf_acompanhante: pacienteSelecionado.cpf_acompanhante,
        obs: pacienteSelecionado.obs,
        cep: pacienteSelecionado.cep,
        tipoendereco: pacienteSelecionado.tipoendereco,
        estado: pacienteSelecionado.estado,
        cidade: pacienteSelecionado.cidade,
        bairro: pacienteSelecionado.bairro,
        endereco: pacienteSelecionado.endereco,
        numero: pacienteSelecionado.numero,
        complemento: pacienteSelecionado.complemento,
        dddtelefone: pacienteSelecionado.dddtelefone,
        telefone: pacienteSelecionado.telefone,
        sigilo: pacienteSelecionado.sigilo,
      };
  
      // Separa os interesses para tratamento especial no FormData
      const interessesIds = pacienteSelecionado.interesses.map(tag => tag.value);

      for (const key in updatedPatientData) {
        if (updatedPatientData[key] !== null && updatedPatientData[key] !== undefined) {
          formData.append(key, updatedPatientData[key]);
        }
      }

      // Adiciona os interesses corretamente como um array para o PHP
      interessesIds.forEach(id => formData.append('interesses[]', id));

      // Adiciona a NOVA foto se uma foi selecionada
      if (fotoPaciente) {
        formData.append('foto', fotoPaciente); // 'foto' é o nome do campo esperado pela API
      }

      // Faz a requisição POST (com _method=PUT se necessário) com FormData
      const response = await axios.post( // Usa POST para FormData
        `/api/pacientes/${pacienteSelecionado.id}`, 
        formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          params: { _method: 'PUT' } // Adiciona _method=PUT se o backend espera assim
        });

      if (response.status === 200) { // 200 OK for successful update
        const updatedPaciente = response.data.paciente;
        const updatedPacientesList = pacientes.map(p => 
          p.id === pacienteSelecionado.id ? response.data.paciente : p 
        );
        setPacientes(updatedPacientesList);
        // Notifica o pai para atualizar o paciente na lista principal, sem recarregar tudo.
        onPatientUpdated(updatedPaciente); 
        handleCloseModal();
        // alert('Paciente atualizado com sucesso!'); // Removido para uma melhor UX
      } else {
        console.error('Error updating patient:', response.data);
        alert('Erro ao atualizar paciente. Por favor, tente novamente.');
      }
    } catch (error) {
      console.error('Error updating patient:', error);
      let msg = 'Erro ao atualizar paciente. Por favor, verifique sua conexão.';
      if (error.response && error.response.data) {
        if (error.response.data.errors) {
          msg = Object.values(error.response.data.errors).flat().join('\n');
        } else {
          msg = error.response.data.message || msg;
        }
      }
      msg = msg.replace(/The cpf has already been taken/gi, 'Este CPF já está cadastrado.');
      msg = msg.replace(/The email has already been taken/gi, 'Este E-mail já está cadastrado.');
      showAlertModal('Erro', msg, 'danger');
    }
  };

  const handleDeletar = async (id) => {
    setPacienteToDelete(id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    setIsLoading(true); // Show loading indicator

    try {
      await axios.delete(`/api/pacientes/${pacienteToDelete}/soft-delete`);
      // Atualiza a lista local
      setPacientes(pacientes.filter((p) => p.id !== pacienteToDelete));
      
      // Notifica o pai para atualizar a lista principal
      onPatientDeleted(pacienteToDelete);
    } catch (error) {
      console.error('Erro ao deletar paciente:', error);
      alert('Erro ao excluir paciente. Por favor, tente novamente.');
    } finally {
      setShowDeleteModal(false);
      setPacienteToDelete(null);
      setIsLoading(false); // Hide loading indicator
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    // Limpa a classe de erro ao começar a digitar no campo de email
    if (name === 'email' && emailRef.current) {
      emailRef.current.classList.remove('is-invalid');
    }
    setPacienteSelecionado(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // Handler para mudança da foto do paciente
  const handleFotoChange = (event) => {
    const file = event.target.files[0];
    setFotoPaciente(file);
    if (file) {
      setPreviewFotoPaciente(URL.createObjectURL(file));
    } else {
      setPreviewFotoPaciente(null);
    }
  };

    // Função para parar o stream da câmera
    const stopCameraStream = () => {
      if (cameraStream) {
        cameraStream.getTracks().forEach(track => track.stop());
        setCameraStream(null);
      }
    };
  
    // Função para abrir o modal da câmera e iniciar o stream
    const handleOpenCamera = async () => {
      stopCameraStream(); // Para qualquer stream anterior
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: "user", // Prioriza câmera frontal
            // Tenta definir uma resolução mais próxima de 3x4 (opcional)
            // width: { ideal: 480 },
            // height: { ideal: 640 }
          },
          audio: false
        });
        setCameraStream(stream);
        setShowCameraModal(true);
        // Liga o stream ao elemento de vídeo quando o modal estiver pronto
        setTimeout(() => {
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
          }
        }, 100); // Pequeno delay para garantir que o modal renderizou
      } catch (err) {
        console.error("Erro ao acessar a câmera: ", err);
        alert("Não foi possível acessar a câmera. Verifique as permissões do navegador.");
      }
    };
  
    // Função para fechar o modal da câmera
    const handleCloseCamera = () => {
      stopCameraStream();
      setShowCameraModal(false);
    };
  
    // Função para capturar a foto do vídeo
    const handleCapturePhoto = () => {
      if (videoRef.current && canvasRef.current) {
        const video = videoRef.current;
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
  
        // Define as dimensões do canvas para a proporção 3x4 (ex: 300x400)
        // O backend pode redimensionar para 113x151, mas enviar uma imagem maior com a proporção correta é bom.
        const targetCanvasWidth = 150;
        const targetCanvasHeight = 200;
        const targetAspectRatio = targetCanvasWidth / targetCanvasHeight; // 3/4

        canvas.width = targetCanvasWidth;
        canvas.height = targetCanvasHeight;

        const videoWidth = video.videoWidth;
        const videoHeight = video.videoHeight;
        const videoAspectRatio = videoWidth / videoHeight;

        let sx = 0; // Ponto X de início no vídeo (source x)
        let sy = 0; // Ponto Y de início no vídeo (source y)
        let sWidth = videoWidth; // Largura da área a ser capturada do vídeo (source width)
        let sHeight = videoHeight; // Altura da área a ser capturada do vídeo (source height)

        // Calcula a área de corte (crop) do vídeo para manter a proporção 3:4, centralizando a captura
        if (videoAspectRatio > targetAspectRatio) {
          // Vídeo é mais largo que o alvo (ex: 16:9). Cortaremos as laterais.
          sWidth = videoHeight * targetAspectRatio; // Calcula a largura da fonte para manter a proporção do alvo
          sx = (videoWidth - sWidth) / 2; // Centraliza o corte horizontalmente
        } else if (videoAspectRatio < targetAspectRatio) {
          // Vídeo é mais alto que o alvo (ex: câmera de celular na vertical). Cortaremos o topo/base.
          sHeight = videoWidth / targetAspectRatio; // Calcula a altura da fonte para manter a proporção do alvo
          sy = (videoHeight - sHeight) / 2; // Centraliza o corte verticalmente
        }
        // Se videoAspectRatio === targetAspectRatio, não é necessário cortar (sx, sy, sWidth, sHeight já estão corretos)

        // Desenha a parte recortada do vídeo (sx, sy, sWidth, sHeight)
        // no canvas inteiro (0, 0, canvas.width, canvas.height), redimensionando-a para preencher o canvas.
        context.drawImage(video, sx, sy, sWidth, sHeight, 0, 0, canvas.width, canvas.height);
  
        // Converte o canvas para um Blob (melhor para enviar via FormData)
        canvas.toBlob(blob => {
          setFotoPaciente(blob); // Guarda o Blob no estado
          setPreviewFotoPaciente(URL.createObjectURL(blob)); // Atualiza o preview
          handleCloseCamera(); // Fecha o modal da câmera
        }, 'image/jpeg', 0.9); // Formato e qualidade
      }
    };

    // Handler específico para o campo de telefone com máscara
  const handlePhoneChange = (event) => {
    const value = event.target.value;
    // Remove todos os caracteres não numéricos para obter apenas os dígitos
    const justNumbers = value.replace(/\D/g, '');
    const ddd = justNumbers.substring(0, 2);
    const number = justNumbers.substring(2);

    setPacienteSelecionado(prev => ({
      ...prev,
      dddcelular: ddd,
      celular: number,
    }));
  };


  const handleCEP = async (event) => {
    
    const cep = event.target.value.replace(/\D/g, '');
      if (cep.length === 8) {
          const response = await buscarEnderecoPorCep(cep);

          if (response.erro) {
            setPacienteSelecionado({
              ...pacienteSelecionado,
              cep,
              logradouro: '',
              bairro: '',
              localidade: '',
              uf: '',
              estado: '',
              cidade: '',
              endereco: '',
              complemento: ''
            }); 
            
          } else {
            setPacienteSelecionado({
              ...pacienteSelecionado,
              cep,
              logradouro: response.logradouro,
              bairro: response.bairro,
              localidade: response.localidade,
              uf: response.uf,
              estado: response.estado,
              cidade: response.localidade,
              endereco: response.logradouro,
              complemento: response.complemento
            }); 
          }
          
      }else {
        // Limpar os campos de endereço
        setPacienteSelecionado({
          ...pacienteSelecionado,
          logradouro: '',
          bairro: '',
          localidade: '',
          uf: '',
          estado: '',
          cidade: '',
          endereco: '',
          complemento: ''
        }); 
      }
  };

  const handleShowProntuario = (paciente) => {
    setPacienteParaVisualizar(paciente);
    setShowProntuarioModal(true);
  };  

  
  

  // --- COLUNAS DA TABELA AGORA SÃO DINÂMICAS ---
  const columns = useMemo(() => {
    // Define a estrutura base das colunas que são sempre visíveis
    const baseColumns = [
      {
        header: '', // Cabeçalho vazio para a coluna da foto
        key: 'foto',
        render: (paciente) => (
          paciente.foto_path ? (
            <Image
              src={`${config.apiBaseURL}/storage/${paciente.foto_path}`}
              alt="Foto do Paciente"
              roundedCircle
              style={{ width: '40px', height: '40px', objectFit: 'cover' }}
            />
          ) : (
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              backgroundColor: '#e9ecef',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              color: '#6c757d',
              fontWeight: 'bold'
            }}>
              {paciente.nome ? paciente.nome.charAt(0).toUpperCase() : '?'}
            </div>
          )
        )
      },
      { header: 'Nome', key: 'nome' },
      // A coluna de Email será inserida aqui condicionalmente
      {
        header: 'Interesses',
        key: 'interesses',
        className: 'd-none d-lg-table-cell',
        render: (paciente) => (
          <div>
            {paciente.interesses && paciente.interesses.length > 0 ? (
              paciente.interesses.map(tag => (
                <Badge key={tag.id} bg="secondary" className="me-1 fw-normal">
                  {tag.nome}
                </Badge>
              ))
            ) : (
              <span className="text-muted fst-italic">Nenhum</span>
            )}
          </div>
        )
      },
      {
        header: 'Ações',
        key: 'acoes',
        render: (paciente) => (
          <>
            {/* Botão Editar: Visível para todos, exceto Médico */}

          {currentUserRole !== 'Médico' && (
            <Button variant="primary" size="sm" onClick={() => handleEditar(paciente)} className="me-2">
              <span className="d-none d-md-inline">Editar</span>
              <span className="d-inline d-md-none">E</span>
            </Button>
          )}

          {/* Botão Deletar: Visível apenas para Representante Legal */}
          {currentUserRole === 'Representante Legal' && (
            <Button variant="danger" size="sm" onClick={() => handleDeletar(paciente.id)}>
              <span className="d-none d-md-inline">Deletar</span>
              <span className="d-inline d-md-none">X</span>
            </Button>
          )}
           {/* <Button variant="secondary" size="sm" onClick={() => handleShowAnamnese(paciente)}>
            <span className="d-none d-md-inline">Anamnese</span>
            <span className="d-inline d-md-none">A</span>
          </Button>{' '} */}

          {(currentUserRole === 'Representante Legal' || currentUserRole === 'Médico') && (
            <Button variant="info" size="sm" onClick={() => handleShowProntuario(paciente)}> 
              <span className="d-none d-md-inline">Prontuário</span>
              <span className="d-inline d-md-none">P</span>
            </Button>
          )}
          </>
        ),
      },
    ];

    // Condição: Se o perfil do usuário NÃO for 'Médico', insere a coluna de Email
    if (currentUserRole !== 'Médico') {
      baseColumns.splice(2, 0, { // Insere na posição 2 (depois de 'Nome')
        header: 'Email',
        key: 'email',
        className: 'd-none d-md-table-cell'
      });
    }

    return baseColumns;
  }, [currentUserRole]); // A dependência é o perfil do usuário

  const pacientesFiltrados = useMemo(() => {
    if (searchTerm.length < 3) {
      return pacientes;
    } else {
      const termoNormalizado = normalizeString(searchTerm);
      return pacientes.filter((paciente) =>
        normalizeString(paciente.nome).includes(termoNormalizado)
      );
    }
  }, [pacientes, searchTerm]);

  // Lógica de paginação aplicada aos dados já filtrados
  const indexOfLastPaciente = activePage * itemsPerPage;
  const indexOfFirstPaciente = indexOfLastPaciente - itemsPerPage;
  const currentPacientes = pacientesFiltrados.slice(indexOfFirstPaciente, indexOfLastPaciente);
  const totalPages = Math.ceil(pacientesFiltrados.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };


  return (
    <div>
      <h1>Pacientes</h1>
      <Row className="mb-3">
        <Col md={3}>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Buscar por nome..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col md={4} className="text-end"> {/* Alinha o botão à direita */}
          <Button variant="success" onClick={handleShowModal}>
            Novo Paciente
          </Button>
          {/* Botão de Importação visível apenas para perfis autorizados */}
          {(currentUserRole === 'Representante Legal' || currentUserRole === 'Recepção') && (
            <Button variant="outline-primary" onClick={() => setShowImportModal(true)} className="ms-2">
              Importar Pacientes em Lote
            </Button>
          )}
        </Col>
      </Row>

      {/* NOVO: Renderiza o modal de visualização do prontuário */}
      <ProntuarioVisualizacaoModal 
        show={showProntuarioModal}
        onHide={() => setShowProntuarioModal(false)}
        paciente={pacienteParaVisualizar}
      />

      <TableComponent 
        columns={columns} 
        data={currentPacientes} // Usa os dados paginados
        className="table-listar" 
      />

      {totalPages > 1 && (
        <Pagination className="justify-content-center">
          <Pagination.Prev
            onClick={() => handlePageChange(activePage - 1)}
            disabled={activePage === 1}
          />
          {Array.from({ length: totalPages }, (_, i) => (
            <Pagination.Item
              key={i + 1}
              active={i + 1 === activePage}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(activePage + 1)}
            disabled={activePage === totalPages}
          />
        </Pagination>
      )}

      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{modoEdicao ? 'Editar Paciente' : 'Novo Paciente'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showAlert && (
            <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
              {alertMessage}
            </Alert>
          )}

          {/* Add a loading indicator inside the modal body */}
          {isLoading && (
            <div className="text-center">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Carregando...</span>
              </Spinner>
              <p>{isLoadingMessage}</p>
            </div>
          )}

          <Tabs
            activeKey={activeModalTabKey}
            onSelect={(k) => setActiveModalTabKey(k)}
            id="paciente-modal-tabs"
            className="mb-3"
          >
            <Tab eventKey="dadosPrincipais" title="Dados Principais">
                {/* Foto e campos obrigatórios */}
                
            <Form className="mt-3"> {/* Adiciona margem ao Form */}
                <Row>
                  {/* Coluna da Foto */}
                  <Col md={4} className="photo-upload-container d-flex flex-column align-items-center mb-3">
                    <Form.Label>Foto do Paciente:</Form.Label>
                    {/* Preview da Foto */}
                    <div className="mb-2">
                      {previewFotoPaciente ? (
                        <img src={previewFotoPaciente} alt="Preview" className="photo-preview" />
                      ) : (
                        // Placeholder se não houver foto
                        <div className="photo-preview d-flex align-items-center justify-content-center text-muted">
                          3x4
                        </div>
                      )}
                    </div>
                    {/* Botão para abrir a câmera */}
                    <Button variant="outline-primary" onClick={handleOpenCamera} className="w-100">
                      Capturar Foto
                    </Button>
                  </Col>

                      {/* Coluna dos Primeiros Campos */}
                  <Col md={8}>
                    <Form.Group as={Row} controlId="nome" className="mb-2">
                      <Form.Label column sm={3}>Nome Completo:</Form.Label>
                      <Col sm={9}>
                        <Form.Control
                          type="text"
                          name="nome"
                          value={pacienteSelecionado.nome}
                          onChange={handleChange}
                          required
                          ref={nomeRef}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-2"> {/* controlId="cpf" removido */}
                      <Form.Label column sm={3}>CPF:</Form.Label>
                      <Col sm={9}>
                        <InputMask
                          mask="999.999.999-99"
                          type="text"
                          name="cpf"
                          id="cpf"
                          className="form-control"
                          value={pacienteSelecionado.cpf}
                          onChange={handleChange}
                          placeholder="Digite o CPF"
                          ref={cpfRef}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="dataNascimento" className="mb-2">
                      <Form.Label column sm={3}>Data Nasc.:</Form.Label>
                      <Col sm={9}>
                        <DatePicker
                          selected={pacienteSelecionado.data_nascimento} // Agora usa diretamente o valor do estado
                          onChange={(date) => setPacienteSelecionado(prev => ({ ...prev, data_nascimento: date }))}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="email" className="mb-2">
                      <Form.Label column sm={3}>Email:</Form.Label>
                      <Col sm={9}>
                        <Form.Control
                          type="email"
                          name="email"
                          value={pacienteSelecionado.email}
                          onChange={handleChange}
                          ref={emailRef}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="celularCompleto" className="mb-2">
                        <Form.Label column sm={3}>Celular: *</Form.Label>
                      <Col sm={9}>
                        <InputMask
                          mask="(99) 99999-9999"
                          value={`${pacienteSelecionado.dddcelular || ''}${pacienteSelecionado.celular || ''}`}
                          onChange={handlePhoneChange}
                          required
                        >
                          {(inputProps) => <Form.Control {...inputProps} type="tel" placeholder="(__) _____-____" ref={celularRef} />}
                        </InputMask>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Tab>

            <Tab eventKey="dadosAdicionais" title="Dados Adicionais">
              {isLoadingAdicionais ? (
                <div className="text-center my-3">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Carregando dados adicionais...</span>
                  </Spinner>
                  <p>Carregando dados adicionais...</p>
                </div>
              ) : (
                <Form className="mt-3">
                  {/* Dados Pessoais Adicionais */}
                  <h5>Dados Pessoais</h5>
                  <Row>
                    <Col md={12}>
                      <Form.Group as={Row} controlId="sexo" className="mb-2">
                        <Form.Label column sm={3}>Sexo:</Form.Label>
                        <Col sm={9}>
                          <Form.Control as="select" name="sexo" value={pacienteSelecionado.sexo || 'N'} onChange={handleChange}>
                            <option value="N">Não Informado</option>
                            <option value="M">Masculino</option>
                            <option value="F">Feminino</option>
                            <option value="O">Outros</option>
                          </Form.Control>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="estadoCivil" className="mb-2">
                        <Form.Label column sm={3}>Estado Civil:</Form.Label>
                        <Col sm={9}>
                          <Form.Control as="select" name="estado_civil" value={pacienteSelecionado.estado_civil || 'Nao informado'} onChange={handleChange}>
                            <option value="Nao informado">Selecione</option>
                            <option value="Solteiro">Solteiro(a)</option>
                            <option value="Casado">Casado(a)</option>
                            <option value="Divorciado">Divorciado(a)</option>
                            <option value="Viuvo">Viúvo(a)</option>
                          </Form.Control>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="cor" className="mb-2">
                        <Form.Label column sm={3}>Cor/Raça:</Form.Label>
                        <Col sm={9}>
                          <Form.Control as="select" name="cor" value={pacienteSelecionado.cor || 'Nao Informado'} onChange={handleChange}>
                            <option value="Nao Informado">Selecione</option>
                            <option value="Branca">Branco(a)</option>
                            <option value="Negra">Negro(a)</option>
                            <option value="Parda">Pardo(a)</option>
                            <option value="Amarela">Amarelo(a)</option>
                          </Form.Control>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Form.Group as={Row} controlId="profissao" className="mb-2">
                        <Form.Label column sm="3">Profissão:</Form.Label>
                        <Col sm="6"><Form.Control type="text" name="profissao" value={pacienteSelecionado.profissao || ''} onChange={handleChange} /></Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="nomeMae" className="mb-2">
                        <Form.Label column sm="3">Nome da Mãe:</Form.Label>
                        <Col sm="9"><Form.Control type="text" name="mae" value={pacienteSelecionado.mae || ''} onChange={handleChange} /></Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="nomePai" className="mb-2">
                        <Form.Label column sm="3">Nome do Pai:</Form.Label>
                        <Col sm="9"><Form.Control type="text" name="pai" value={pacienteSelecionado.pai || ''} onChange={handleChange} /></Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="tipoConvenio" className="mb-2">
                        <Form.Label column sm="3">Tipo Convênio:</Form.Label>
                        <Col sm="6">
                          <Form.Control as="select" name="tp_convenio" value={pacienteSelecionado.tp_convenio || ''} onChange={handleChange}>
                            <option value="">Selecione</option>
                            <option value="Particular">Particular</option>
                            <option value="Convenio">Convênio Médico</option>
                            <option value="Outros">Outros</option>
                          </Form.Control>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="opConvenio" className="mb-2">
                        <Form.Label column sm="3">Operadora:</Form.Label>
                        <Col sm="6"><Form.Control type="text" name="op_convenio" value={pacienteSelecionado.op_convenio || ''} onChange={handleChange} /></Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="numConvenio" className="mb-2">
                        <Form.Label column sm="3">Nº Convênio:</Form.Label>
                        <Col sm="6"><Form.Control type="number" name="nu_convenio" value={pacienteSelecionado.nu_convenio || ''} onChange={handleChange} /></Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="numSus" className="mb-2">
                        <Form.Label column sm="3">Cartão SUS:</Form.Label>
                        <Col sm="6"><Form.Control type="number" name="nu_sus" value={pacienteSelecionado.nu_sus || ''} onChange={handleChange} /></Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="nomeAcompanhante" className="mb-2">
                        <Form.Label column sm="3">Acompanhante:</Form.Label>
                        <Col sm="6"><Form.Control type="text" name="nm_acompanhante" value={pacienteSelecionado.nm_acompanhante || ''} onChange={handleChange} /></Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="cpfAcompanhante" className="mb-2">
                        <Form.Label column sm="3">CPF Acomp.:</Form.Label>
                        <Col sm="6"><InputMask mask="999.999.999-99" type="text" className="form-control" name="cpf_acompanhante" value={pacienteSelecionado.cpf_acompanhante || ''} onChange={handleChange} placeholder='Digite o CPF' /></Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="observacoes" className="mb-2">
                        <Form.Label column sm="3">Observações:</Form.Label>
                        <Col sm="9"><Form.Control as="textarea" rows={2} name="obs" value={pacienteSelecionado.obs || ''} onChange={handleChange} /></Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  {/* <h5>Endereço</h5> Comentado pois não há campos de endereço nesta aba */}
                  <Form.Group as={Row} controlId="cep" className="mt-3 mb-2">
                    <Col sm="4">CEP: <InputMask mask="99.999-999" type="text" name="cep" value={pacienteSelecionado.cep || ''} onChange={handleCEP} placeholder='Digite o CEP' /></Col>
                    <Col sm="8">Tipo Endereço:
                      <Form.Control as="select" name="tipoendereco" value={pacienteSelecionado.tipoendereco || 'Residencial'} onChange={handleChange}>
                        <option value="Residencial">Residencial</option>
                        <option value="Comercial">Comercial</option>
                        <option value="Cobrança">Cobrança</option>
                        <option value="Outros">Outros</option>
                      </Form.Control>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="estado" className="mt-3">
                    <Col sm="3">Estado: <Form.Control type="text" name="estado" value={pacienteSelecionado.estado || ''} onChange={handleChange} /></Col>
                    <Col sm="4">Cidade: <Form.Control type="text" name="cidade" value={pacienteSelecionado.cidade || ''} onChange={handleChange} /></Col>
                    <Col sm="5">Bairro: <Form.Control type="text" name="bairro" value={pacienteSelecionado.bairro || ''} onChange={handleChange} /></Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="endereco" className="mt-3">
                    <Col sm="7">Endereço: <Form.Control type="text" name="endereco" value={pacienteSelecionado.endereco || ''} onChange={handleChange} /></Col>
                    <Col sm="3">Nº: <Form.Control type="text" name="numero" value={pacienteSelecionado.numero || ''} onChange={handleChange} /></Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="complemento" className="mb-5">
                    <Col sm="12">Complemento: <Form.Control type="text" name="complemento" value={pacienteSelecionado.complemento || ''} onChange={handleChange} /></Col> {/* Ajustado para sm=12 */}
                  </Form.Group>
                  <hr />
                  <h5>Contato Adicional</h5>
                  <Form.Group as={Row} controlId="celular_adicional" className="mt-3 mb-2"> {/* Renomeado para evitar conflito de ID */}
                    <Col sm="2">DDD: <Form.Control type="text" name="dddcelular_display" value={pacienteSelecionado.dddcelular || ''} readOnly /></Col>
                    <Col sm="6">Celular: <Form.Control type="text" name="celular_display" value={pacienteSelecionado.celular || ''} readOnly /></Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="telefone" className="mb-2">
                    <Col sm="2">DDD: <Form.Control type="text" name="dddtelefone" value={pacienteSelecionado.dddtelefone || ''} onChange={handleChange} /></Col>
                    <Col sm="6">Telefone Fixo: <Form.Control type="text" name="telefone" value={pacienteSelecionado.telefone || ''} onChange={handleChange} /></Col>
                  </Form.Group>
                  <hr />
                  <h5>Informações Sigilosas</h5>
                  <Form.Group as={Row} controlId="sigilo_obs" className="mt-3 mb-2"> {/* Renomeado para evitar conflito de ID */}
                    <Col sm="12">Descrição sigilosa: <Form.Control as="textarea" name="sigilo" value={pacienteSelecionado.sigilo || ''} onChange={handleChange} /></Col>
                  </Form.Group>
                </Form>
              )}
            </Tab> {/* Fim da Aba Dados Adicionais */}

            {/* Nova Aba para Pacotes */}
            <Tab eventKey="pacotes" title="Uso de Pacotes">
              <div className="mt-3">
                {isLoadingHistorico ? (
                  <div className="text-center my-3">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Carregando histórico...</span>
                    </Spinner>
                  </div>
                ) : pacotesHistorico.length > 0 ? (
                  <Accordion defaultActiveKey="0">
                    {pacotesHistorico.map((pacote, index) => (
                      <Accordion.Item eventKey={String(index)} key={pacote.id}>
                        <Accordion.Header>
                          <div className="d-flex justify-content-between w-100 pe-2">
                            <span>{pacote.servico.nome}</span>
                            <Badge pill bg={pacote.status === 'Ativo' ? 'info' : 'success'}>{pacote.status}</Badge>
                            <span>{pacote.sessoes_utilizadas} / {pacote.sessoes_contratadas} sessões</span>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <h6>Histórico de Utilização:</h6>
                          {pacote.agendamentos_utilizados && pacote.agendamentos_utilizados.length > 0 ? (
                            <Table striped bordered hover size="sm">
                              <thead><tr><th>Data</th><th>Hora</th><th>Status</th></tr></thead>
                              <tbody>
                                {pacote.agendamentos_utilizados.map(ag => (
                                  <tr key={ag.id}>
                                    <td>{new Date(ag.data_agendamento + 'T00:00:00').toLocaleDateString('pt-BR')}</td>
                                    <td>{ag.hora_marcada.slice(0, 5)}</td>
                                    <td>{ag.status}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          ) : (<p>Nenhuma sessão utilizada registrada para este pacote.</p>)}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                ) : (<Alert variant="info">Nenhum pacote de sessões encontrado para este paciente.</Alert>)}
              </div>
            </Tab>

            {/* 8. Nova Aba de Interesses */}
            <Tab eventKey="interesses" title="Interesses">
              <Form.Group controlId="tagsInteresse" className="mt-3">
                <Form.Label>Selecione as tags de interesse para este paciente:</Form.Label>
                <Select
                  isMulti
                  options={allTags}
                  isLoading={isLoadingTags}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Selecione..."
                  noOptionsMessage={() => 'Nenhuma tag cadastrada'}
                  value={pacienteSelecionado.interesses}
                  onChange={(selectedOptions) => {
                    setPacienteSelecionado(prev => ({ ...prev, interesses: selectedOptions || [] }));
                  }}
                />
              </Form.Group>
            </Tab>
          </Tabs> {/* Fim das Abas do Modal */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSalvar}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <div className="text-center">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Carregando...</span>
              </Spinner>
              <p>Excluindo paciente...</p>
            </div>
          ) : (
            <p>Tem certeza que deseja excluir este paciente?</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}disabled={isLoading}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}disabled={isLoading}>
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>

        {/* Modal da Câmera */}
      <Modal show={showCameraModal} onHide={handleCloseCamera} centered>
        <Modal.Header closeButton>
          <Modal.Title>Capturar Foto</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {cameraStream ? (
            // Estiliza o vídeo para parecer 3x4 como guia
            <video ref={videoRef} autoPlay playsInline className="camera-video-preview"></video>
          ) : (
            <p>Iniciando câmera...</p>
          )}
          {/* Canvas oculto para captura */}
          <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCamera}>Cancelar</Button>
          <Button variant="primary" onClick={handleCapturePhoto} disabled={!cameraStream}>Capturar Foto</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Importação de Pacientes */}
      <Modal show={showImportModal} onHide={() => setShowImportModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Importar Pacientes via Excel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ImportacaoPacientesTab onClose={() => setShowImportModal(false)} onImportComplete={onPatientCreated} />
        </Modal.Body>
      </Modal>


    {/* Anamnese Modal */}
    <Modal show={showAnamneseModal} onHide={() => setShowAnamneseModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{TIPO_FICHA} | Ficha de Anamnese: {pacienteSelecionado.nome}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {existingAnamnese ? ( // Display existing anamnese if available
            <div>
              <h4>Anamnese Existente:</h4>
              
              {/* <ul>
                {existingAnamnese.respostas.map((resposta) => (
                  <li key={resposta.id}>
                    <strong>{resposta.pergunta.pergunta}:</strong> {resposta.resposta}
                  </li>
                ))}
              </ul> */}
              <Table striped bordered hover size="sm" className="mt-2">
                <tbody>
                  {existingAnamnese.respostas.map((resposta) => (
                    <tr key={resposta.id}>
                      <td><strong>{resposta.pergunta.pergunta}:</strong></td>
                      <td>{resposta.resposta}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : anamnesePerguntas.length > 0 ? ( // Display form if no existing anamnese
            <Form>
              {anamnesePerguntas.map((pergunta, index) => (
                <Form.Group key={pergunta.id} controlId={`pergunta-${pergunta.id}`}>
                  <div className="d-flex align-items-center">
                    <Form.Label className="mr-3 text-left w-50">
                      {index + 1} - {pergunta.pergunta}
                    </Form.Label>
                    <div>
                      <Form.Check
                        inline
                        label="Sim"
                        name={`resposta-${pergunta.id}`}
                        type="radio"
                        id={`resposta-${pergunta.id}-sim`}
                        value="Sim"
                        checked={anamneseRespostas[pergunta.id] === 'Sim'}
                        onChange={(e) => handleAnamneseChange(pergunta.id, e.target.value)}
                      />
                      <Form.Check
                        inline
                        label="Não"
                        name={`resposta-${pergunta.id}`}
                        type="radio"
                        id={`resposta-${pergunta.id}-nao`}
                        value="Não"
                        checked={anamneseRespostas[pergunta.id] === 'Não'}
                        onChange={(e) => handleAnamneseChange(pergunta.id, e.target.value)}
                      />
                    </div>
                  </div>
                </Form.Group>
              ))}
              <Button variant="primary" onClick={() => handleSubmitAnamnese(pacienteSelecionado.id)} disabled={creatingAnamnese}>
                {creatingAnamnese ? 'Salvando...' : 'Salvar Anamnese'}
              </Button>
            </Form>
          ) : (
            <p>Carregando perguntas...</p>
          )}
        </Modal.Body>
      </Modal>


    </div>
  );
};

export default PacientesTab;
